import { render } from "./IconDirectionsBoat.vue?vue&type=template&id=61e262b8"
import script from "./IconDirectionsBoat.vue?vue&type=script&lang=js"
export * from "./IconDirectionsBoat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__